import { InsightError } from '@Common/Helpers/Errors';
import { AbstractInstanceItem, Typed } from '@InstanceFactory';

export class Asserts {
    public static isNotNull<T>(obj: T, message?: string): asserts obj is NotNulls<T> {
        if (_.isNil(obj)) {
            throw new InsightError(`obj is null: ${message}`);
        }
    }

    public static isInstance<T>(value: Typed, instanceItem: AbstractInstanceItem<T>, message?: string): asserts value is T {
        if (instanceItem.isInstanceOfType(value)) {
            throw new InsightError(`value can be ${instanceItem.instanceName}: ${message}`);
        }
    }
}
